import { SUPPORT_ROLE_ID } from "@/types/employee";
import type { Employee } from "./types";

/**
 * Keep the authenticated support employee visible while hiding all other
 * support users from assignment dropdowns.
 */
export function excludeSupportEmployees(
  employees: Employee[],
  preservedEmployeeId?: number | null,
): Employee[] {
  return employees.filter(
    emp => emp.roleId !== SUPPORT_ROLE_ID || emp.id === preservedEmployeeId,
  );
}

export function sortEmployeesByName<T extends { name: string }>(
  employees: T[],
): T[] {
  return [...employees].sort((a, b) =>
    a.name.localeCompare(b.name, "pt-PT", { sensitivity: "base" }),
  );
}
